import React from 'react'
import { isMobile } from 'react-device-detect'
import { TransparentFullScreenModal } from './modal'
import { getFontClassName } from './../../styleFunctions'
import { getLanguageInfo } from './../../common'
import { ImageComp } from './image'
import localization from './../../data/localization.json'
import { useResponsiveSize } from './hooks'
import { useWindowHeight, useWindowWidth } from '@react-hook/window-size'

export const NotificationModal = ({
    opened, closeFunc, language, inOrEx,
}) => {
    const getResponsiveSize = useResponsiveSize()
    const windowWidth = useWindowWidth()
    const windowHeight = useWindowHeight()
    return (
        <TransparentFullScreenModal opened={opened}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%' }}>
                <div
                    className={getFontClassName('bold', language)}
                    style={{ display: 'flex', color: '#fff', fontSize: getResponsiveSize(36, 32), padding: `${getResponsiveSize(22, 24)}px ${getResponsiveSize(20, 20)}px`, paddingTop: 0, borderBottom: '1px solid #fff', marginTop: getResponsiveSize(32, windowWidth > windowHeight ? 40 : 115), marginBottom: getResponsiveSize(54, windowWidth > windowHeight ? 40 : 80) }}
                >
                    {localization['car_page_notification_title'][language]}
                </div>
                <div style={isMobile ? { flex: 1, maxWidth: `calc(100% - ${getResponsiveSize(100, 100)}px`, overflowX: 'hidden', overflowY: 'auto', } : { maxWidth: `calc(100% - ${getResponsiveSize(100, 100)}px`, overflowX: 'hidden', overflowY: 'auto' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingBottom: getResponsiveSize(46, windowWidth > windowHeight ? 18 : 58) }}>
                        <ImageComp style={{ width: getResponsiveSize(145, 145), height: getResponsiveSize(65, 65), marginRight: getResponsiveSize(30, 32) }} src={inOrEx === 'exterior' ? '/static/UI/img-guide-custom.png' : '/static/UI/img-guide-seat.png'} />
                        <div className={getFontClassName('light', language)} style={{ fontSize: getResponsiveSize(24, 23) }}>{localization['car_page_notification_txt_1'][language]}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingBottom: getResponsiveSize(46, windowWidth > windowHeight ? 18 : 58) }}>
                        <ImageComp style={{ width: getResponsiveSize(145, 145), height: getResponsiveSize(65, 65), marginRight: getResponsiveSize(30, 32) }} src={'/static/UI/img-guide-features.png'} />
                        <div className={getFontClassName('light', language)} style={{ fontSize: getResponsiveSize(24, 23) }}>{localization['car_page_notification_txt_2'][language]}</div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', paddingBottom: getResponsiveSize(46, windowWidth > windowHeight ? 18 : 58) }}>
                        <ImageComp style={{ width: getResponsiveSize(145, 145), height: getResponsiveSize(65, 65), marginRight: getResponsiveSize(30, 32) }} src={'/static/UI/img-guide-share.png'} />
                        <div className={getFontClassName('light', language)} style={{ fontSize: getResponsiveSize(24, 23) }}>{localization['car_page_notification_txt_3'][language]}</div>
                    </div>
                </div>
                <div style={{ display: 'flex', }}>
                    <button
                        className={getFontClassName('bold', language)}
                        style={{
                            background: '#fff', border: 'none',
                            width: getResponsiveSize(230, 230), height: getResponsiveSize(77, 77), borderRadius: getResponsiveSize(40, 40),
                            fontSize: getResponsiveSize(26, 26), cursor: 'pointer',
                            marginTop: getResponsiveSize(158, 20), marginBottom: getResponsiveSize(32, windowWidth > windowHeight ? 35 : 115)
                        }}
                        onClick={() => closeFunc()}
                    >
                        {localization['first_showroom_modal_button'][language]}
                    </button>
                </div>
            </div>
        </TransparentFullScreenModal>
    )
}
export const GyroFrameView = ({ gyroEnabled = false, language, closeFunc = () => { } }) => {
    const getResponsiveSize = useResponsiveSize()
    const windowWidth = useWindowWidth()
    const windowHeight = useWindowHeight()
    return (
        <>
            {(isMobile && gyroEnabled) ? (
                <ImageComp src={'/static/UI/btn-close.png'} style={{
                    position: 'fixed', top: windowWidth > windowHeight ? getResponsiveSize(48, 18) : getResponsiveSize(48, 24), cursor: 'pointer', zIndex: 20,
                    [getLanguageInfo(language).rtl ? 'left' : 'right']: windowWidth > windowHeight ? getResponsiveSize(48, 18) : getResponsiveSize(48, 45),
                    width: getResponsiveSize(34, 28), height: getResponsiveSize(34, 28)
                }} onClick={closeFunc} />
            ) : null}
        </>
    )
}
